import { API } from '@shared/types/api';
import { useChannelUsers } from './useChannelUsers';
import { useWorkflowChannel } from './useWorkflowChannel';

/**
 * A hook that returns the associated users for a given workflow template id.
 * @param workflowTemplateId - The id of the workflow template.
 * @returns The users for the given workflow template id.
 */
export function useWorkflowUsers(workflowTemplateId?: string): API.ShortUserFragment[] {
  const channel = useWorkflowChannel(workflowTemplateId);
  const { users } = useChannelUsers({ channelId: channel?.id });
  return users;
}
